import React from 'react';
import ReactPlayer from 'react-player';

const ReactVideoPlayer = ({ url, autoplay }) => {
    return (
        <div className='video-wrapper'>
            <ReactPlayer
                url={url}
                controls
                playing={autoplay}
                width='100%'
                height='100%'
            />
        </div>
    );
};

export default ReactVideoPlayer;
